import { render, staticRenderFns } from "./ComputerVision.vue?vue&type=template&id=1f48aa0d&scoped=true&"
import script from "./ComputerVision.vue?vue&type=script&lang=js&"
export * from "./ComputerVision.vue?vue&type=script&lang=js&"
import style0 from "./ComputerVision.vue?vue&type=style&index=0&id=1f48aa0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f48aa0d",
  null
  
)

export default component.exports